/* raw layout hash: _provider-profile-accreditation-management-layout:6cb18ab21d5ca28d893adad23c196ccff5549b4573ef319649050bf0f7985448 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_provider-profile-accreditation-management-layout" — renders its page content through the router outlet.
export default function ProviderProfileAccreditationManagementLayout() {
  return <AppShell layoutName="_provider-profile-accreditation-management-layout" menu={LAYOUT_MENUS['_provider-profile-accreditation-management-layout']} />;
}
